import { Navigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import { getShowSplits } from 'app/store/SongList/selectors';
import { routes } from 'app/routing/routesConfig';
import React from 'react';
import { CurrentSplit } from 'app/components/Song';

export const SplitsRoute = () => {
  const { guid } = useParams();
  const showSplits = useAppSelector(getShowSplits);

  if (showSplits) {
    return <CurrentSplit />;
  }

  return (
    <Navigate
      to={guid ? routes.songAudioList.path.replace(':guid', guid) : '/'}
    />
  );
};
